import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, format, isSameMonth, isWithinInterval, subDays, isSameDay, } from "date-fns";
const dayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
function CalendarView(props) {
    const { duration, setDuration, onRangeChange, month, setSelectedOption, selectedOption } = props;
    const handleCellClick = (date) => {
        setSelectedOption("Custom Range");
        if (duration.from && duration.to) {
            setDuration({ from: date, to: null });
        }
        else if (duration.from && date > duration.from) {
            setDuration(Object.assign(Object.assign({}, duration), { to: date }));
            onRangeChange(duration.from, date);
        }
        else {
            setDuration({ from: date, to: null });
        }
    };
    const startDate = startOfWeek(startOfMonth(month));
    const endDate = endOfWeek(endOfMonth(month));
    const daysInMonth = eachDayOfInterval({ start: startDate, end: endDate });
    const checkSelectedOption = selectedOption === "Today" || selectedOption === "Yesterday" || isSameDay(duration.from, duration.to) || !duration.to;
    return (_jsxs(Box, Object.assign({ sx: {
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            gridTemplateRows: "auto repeat(6, 1fr)",
            gridRowGap: "5px",
            width: "90%",
            margin: "0 auto",
            paddingBottom: "10px"
        } }, { children: [dayNames.map((dayName) => (_jsx(Typography, Object.assign({ variant: "subtitle2", sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                } }, { children: dayName }), dayName))), daysInMonth.map((date, idx) => {
                let disabled = !isSameMonth(date, month);
                let checkIsSameDay = isSameDay(date, duration.from) || isSameDay(date, duration.to);
                let isWithininterval = !isSameDay(duration.from, duration.to) && duration.from && duration.to
                    ? isWithinInterval(date, { start: duration.from, end: subDays(duration.to, 1) })
                    : false;
                return (_jsx(Box, Object.assign({ sx: {
                        backgroundColor: checkIsSameDay ? "#F5F4FC" : "",
                        borderRadius: checkSelectedOption ? '50%' : isSameDay(date, duration.from) ? "50% 0% 0% 50%" : isSameDay(date, duration.to) ? "0% 50% 50% 0%" : "",
                        visibility: disabled ? "hidden" : "visible",
                    } }, { children: _jsx(Typography, Object.assign({ variant: "h5", onClick: () => handleCellClick(date), sx: {
                            backgroundColor: checkIsSameDay ? "#6E60C4" : isWithininterval ? "#F5F4FC" : "#fff",
                            color: checkIsSameDay ? "common.white" : isWithininterval ? "common.black" : "",
                            borderRadius: checkIsSameDay ? "50%" : 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "39px",
                            cursor: "pointer"
                        } }, { children: format(date, "d") })) }), idx));
            })] })));
}
export default CalendarView;
